import { Spin } from 'antd';
import { StyledExternalActivity } from './ExternalActivity.styled';

export default function ExternalActivity({ taskActivityConf }) {
  return (
    <StyledExternalActivity>
      {taskActivityConf?.iframeUrl ? (
        <iframe
          src={taskActivityConf.iframeUrl}
          webkitallowfullscreen
          mozallowfullscreen
          allowFullScreen
        ></iframe>
      ) : (
        <Spin />
      )}
    </StyledExternalActivity>
  );
}
